import { useRef, useEffect, useCallback } from "react";
import debounce from "lodash.debounce";

export const useDebouncedCallback = (callback, delay = 500) => {
  const callbackRef = useRef(callback);
  const debouncedRef = useRef();
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    debouncedRef.current = debounce((...args) => {
      callbackRef.current(...args);
    }, delay);

    return () => {
      debouncedRef.current.cancel();
    };
  }, [delay]);

  return useCallback((...args) => {
    debouncedRef.current?.(...args);
  }, []);
};
